import { getPlayerData } from "core-integration/src/store/player/reducers";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";

const LoggedIn: React.FC = () => {
  const player = useSelector(getPlayerData);
  if (!player) {
    return <Navigate to="/" />;
  } else if (!player.entry) {
    return <Navigate to="/squad-selection" />;
  }
  return <Navigate to="/my-team" />;
};

export default LoggedIn;
